import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./components/Home";
import NotFound from "./components/NotFound";

import "./App.css";
import Privacy from "./components/Privacy";
import Companies from "./components/Companies";
import About from "./components/About";
import Contact from "./components/Contact";
import VoiceAi from "./components/VoiceAi";
import Pricing from "./components/Price";
import Faqs from "./components/Faqs";
import BookADemo from "./components/BookADemo";
import Services from "./components/Services";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/about" element={<About />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/voiceai" element={<VoiceAi />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/book-a-demo" element={<BookADemo />} />

        <Route path="/*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
